import React from 'react';
import PropTypes from 'prop-types';
import css from './DegreePlusOffice.module.scss';
import { generateUniqueId } from '../../../../common/utils/utils';
import { svgSprite } from '../../../../hybrid/wrappers';
import classNames from 'classnames';

const DegreePlusOffice = ({ getHandlers, val }) => {
    const isValueNegative = val.startsWith('-');
    return (
        <div {...getHandlers(false)} className={css.wrapper} key={generateUniqueId()}>
            <div className={css.icon}>
                {svgSprite('arrow-small', { className: classNames(css.arrow, { [css.arrowDown]: isValueNegative }) })}
            </div>
            <p>{val?.replace('-', '')}</p>
        </div>
    );
};
DegreePlusOffice.propTypes = {
    getHandlers: PropTypes.func,
    gridStyles: PropTypes.object,
    name: PropTypes.string,
    val: PropTypes.oneOfType([PropTypes.object, PropTypes.number, PropTypes.string])
};
export default DegreePlusOffice;
